export interface IAgentReport {
  id: number;
  code: string;
  name: string;
}
